module.exports = __webpack_public_path__ + "img/partner1.7b502790.png";